// Pipeline stages — 02 §3. NINE, definitive. Every stage is independently runnable (D65/D67).
export const STAGES = [
    'discovery',
    'details',
    'harvest',
    'audit',
    'identity',
    'resolve',
    'score',
    'documents',
    'client_audit',
    'digests',
];
/** The lead-side stages; the /pipeline UI exposes exactly these as checkboxes (04 §6). */
export const LEAD_STAGES = STAGES.slice(0, 8);
/** Client-side stages, reachable from the UI as two explicit buttons (04 §6). */
export const CLIENT_STAGES = ['client_audit', 'digests'];
/** Dispatch presets — 02 §3. `existing` and `resolve` cost $0 (no Places calls). */
export const PRESETS = {
    full: LEAD_STAGES,
    existing: ['harvest', 'audit', 'identity', 'resolve', 'score', 'documents'],
    resolve: ['identity', 'resolve', 'score', 'documents'],
};
/**
 * Phase gate (02 §3): dispatch executes `requested ∩ implemented` and records the remainder as
 * 'skipped_unimplemented'. The UI greys out the rest with its phase label. Never fake a stage.
 * `resolve` was moved into Phase A on owner feedback: the unit being sold is a WEBSITE, so
 * leads sharing a domain are one prospect and must be grouped before the list is usable. The
 * full six-signal practitioner↔clinic matching still belongs to WP-B3.
 */
export const IMPLEMENTED_STAGES = [
    'discovery',
    'details',
    'harvest',
    'audit',
    'resolve',
    'identity',
    'score',
    'documents',
    'client_audit',
    'digests',
];
export const STAGE_PHASE = {
    discovery: 'A',
    details: 'A',
    harvest: 'B',
    audit: 'A',
    identity: 'A',
    resolve: 'B',
    score: 'A',
    documents: 'A',
    client_audit: 'C',
    digests: 'C',
};
export function isImplemented(stage) {
    return IMPLEMENTED_STAGES.includes(stage);
}
//# sourceMappingURL=stages.js.map